/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function o(o){window.MotionDebug&&window.MotionDebug.record(o)}export{o as record};
//# sourceMappingURL=record.js.map
